exports.default = {
  'invitation_code': '邀请码',
  'enter_invitation_code': '请填写邀请码',
  'join_team_applied': '您已成功申请加入团队！等待管理员审核后将加入团队',
  'join_team_success': '您已成功加入团队！',
  'join_team_invitation': '团队邀请',
  'join_team_title_fallback': '加入团队',
  'join_team_invited_by': '{name} 邀请你加入团队',
  'join_team_invited_default': '你的同事邀请你加入团队',
  'join_team_visual_note': '与团队成员在 PAITEAMS 中协作，共同推进工作。',
  'join_team_invalid_title': '邀请链接已失效',
  'join_team_invalid_description': '该邀请可能已过期、被重置或对应团队不可用，请联系邀请人获取新链接。',
  'join_team_return_home': '返回首页',
  'join_team_heading': '加入 {team}',
  'join_team_already_member_title': '你已在该团队中',
  'join_team_already_member_description': '无需再次验证，可以直接返回 {team}。',
  'join_team_back_to_team': '回到团队',
  'join_team_current_account': '当前账号',
  'join_team_current_user': '当前用户',
  'join_team_verified': '已验证',
  'join_team_verification_method': '验证方式',
  'join_team_phone_verification': '手机验证',
  'join_team_email_verification': '邮箱验证',
  'join_team_real_name_optional': '姓名（选填）',
  'join_team_agreement_prefix': '我已阅读并同意',
  'join_team_joining': '正在加入...',
  'join_team_logged_in_description': '确认账号信息后即可加入，无需再次验证。',
  'join_team_verify_description': '验证你的账号后，即可接受这次团队邀请。',
  'join_team_failed': '加入团队失败，请稍后重试',
  'team_name': '团队名称',
  'enter_team_name': '请输入团队名称',
  'industry': '所属行业',
  'company_size': '公司规模',
  'select_company_size': '请选择公司规模',
  'team_name_required': '请输入公司名称',
  'team_name_length': '公司名称长度应大于3个字符小于100字符',
  'industry_required': '请选择行业',
  'size_required': '请选择公司人数',
  'size_1_10': '1~10人',
  'size_11_50': '11~50人',
  'size_51_100': '51~100人',
  'size_101_300': '101~300人',
  'size_301_1000': '301~1000人',
  'size_1001_plus': '1001人及以上',
  'team_created': '团队创建成功！',
  'qrcode_invitation': '二维码邀请',
  'link_invitation': '链接邀请',
  'mobile_invitation': '手机邀请',
  'mobile_phone': '手机号码',
  'enter_your_mobile_phone_number': '请输入手机号码',
  'copy': '复制',
  'copy_succeeded': '复制成功',
  'team_as_soon_as_possible3': '团队邀请发送成功',
  'please_fill_in_the_invitation_form': '请填写邀请表单',
  'please_fill_in_the_invitation_email': '请填写邀请邮箱',
  'please_enter_your_mobile_number': '请输入手机号码',
  'the_correct_mobile_phone_number': '请输入正确的手机号码',
  'invitation_expiry_time': '邀请方式失效时间：',
  'reset': '重置',
  'please_enter_your_real_name': '请输入您的真实姓名',
  'join_now': '立即加入',
  'service_agreement': '服务协议',
  'privacy_policy': '《隐私政策》',
  'agreement_consent_text': '点击立即加入代表你已阅读并同意',
  'invalid_phone': '请输入合法的手机号',
  'team_management': '团队管理',
  'edit_avatar': '修改头像',
  'nickname': '昵称',
  'modify_nickname': '修改昵称',
  'phone': '手机',
  'rebind': '重新绑定',
  'password': '密码',
  'reset_password': '重置密码',
  'crop_image': '剪切图片',
  'crop_image_question': '是否需要剪切图片？',
  'crop': '剪切',
  'upload_without_crop': '不剪切直接上传',
  'upload_image': '上传图片',
  'cancel': '取 消',
  'confirm': '确 定',
  'verification_code': '验证码',
  'next_step': '下一步',
  'new_password': '新密码',
  'confirm_password': '确认密码',
  'enter_new_password': '请输入新密码',
  'confirm_new_password_again': '请再次输入新密码',
  'confirm_modification': '确认修改',
  'enter_mobile_number': '请输入手机号码',
  'enter_verification_code': '请输入验证码',
  'get_verification_code': '获取验证码',
  'input_nickname': '请输入昵称',
  'old_phone_number': '旧手机号',
  'new_phone_number': '新手机号',
  'please_enter_nickname': '请修改您的昵称',
  'save_success': '保存成功！',
  'and': '和',
  'image_type_error': '图片类型必须是.gif,jpeg,jpg,png,bmp中的一种',
  'verification_code_sent': '获取短信验证码成功，请留意您的短信',
  'verification_code_empty': '获取验证码手机号不能为空',
  'verification_failed': '验证码校验失败',
  'check_account_verification': '请检查账号验证码是否填写正确',
  'password_reset_success': '密码已重置！请重新登录！',
  'enter_new_password': '请填写新密码',
  'phone_reset_success': '手机已重置！请重新登录！',
  'bind_phone_first': '您还未绑定手机，请先进行手机绑定！',
  'password_requirements': '必须包含大小写字母数字，至少8个字符',
  'password_confirmation': '请再次确认密码',
  'password_mismatch': '请保持两次密码一致!',
  'phone_required': '手机号不能为空',
  'phone_invalid': '请输入正确的手机号',
  '6_digit_verification_code': '请输入6位验证码'
}
